module.exports = __webpack_public_path__ + "media/images/gray_jean_light-a551172b383d7b60bd7698e2ed630155.png";